// extracted by mini-css-extract-plugin
export var content = "_mk-1";
export var fullScreen = "_mk-0";